import React, { useState } from "react";
import { Tab, Tabs } from "@mui/material";
import TrackChecklists from "./TrackChecklists";
import RelatedChecklists from "./RelatedChecklists";

export default function Checklist() {
  const [switchScreen, setSwitchScreen] = useState({
    primary: "TrackChecklists",
  });

  const primaryTabs = [
    {
      label: "Track Checklists",
      value: "TrackChecklists",
    },
    {
      label: "Related Checklists",
      value: "RelatedChecklists",
    },
  ];

  return (
    <div className="w-full flex flex-col gap-3">
      <div>
        <Tabs
          value={switchScreen.primary}
          onChange={(event, newValue) => {
            setSwitchScreen({ ...switchScreen, primary: newValue });
          }}
        >
          {primaryTabs.map((tab, index) => (
            <Tab key={index} label={tab.label} value={tab.value} />
          ))}
        </Tabs>
      </div>
      {switchScreen.primary === "TrackChecklists" ? (
        <>
          <TrackChecklists />
        </>
      ) : (
        <></>
      )}
      {switchScreen.primary === "RelatedChecklists" ? (
        <>
          <RelatedChecklists />
        </>
      ) : (
        <></>
      )}
    </div>
  );
}
